import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-72 rounded-2xl p-2 text-popover-foreground',
        // Match the Card glass treatment so popovers (More menu, account
        // menu, meeting Mark-as-focus) read like part of the same surface
        // family rather than the boxy MUI menu they were originally.
        'border border-white/45 bg-white/70 dark:border-border dark:bg-popover/95',
        'backdrop-blur-2xl backdrop-saturate-150',
        // saturate-150 over a bright backdrop tints the text; neutralise it in dark
        'dark:backdrop-saturate-100',
        'shadow-[0_2px_4px_rgba(15,23,42,0.06),0_24px_60px_-20px_rgba(15,23,42,0.22)]',
        'dark:shadow-[0_2px_4px_rgba(0,0,0,0.5),0_24px_60px_-20px_rgba(0,0,0,0.6)]',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        'data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1',
        'data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
